// One authored icon set: 24px grid, 1.75 stroke, round joins, drawn for this game.

const PATHS = {
  sound: (
    <>
      <path d="M4 9.5h3.2L12 5.5v13l-4.8-4H4z" />
      <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />
    </>
  ),
  mute: (
    <>
      <path d="M4 9.5h3.2L12 5.5v13l-4.8-4H4z" />
      <path d="M16 9.5l5 5M21 9.5l-5 5" />
    </>
  ),
  share: (
    <>
      <path d="M12 3.5v11M8 7.5l4-4 4 4" />
      <path d="M6 11H4.5v9.5h15V11H18" />
    </>
  ),
  qr: (
    <>
      <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" />
      <path d="M14 14h2.5v2.5H14zM17.5 17.5H20V20h-2.5zM14 20h2M20 14v1.5" />
    </>
  ),
  host: (
    <>
      <circle cx="8" cy="12" r="3.5" />
      <path d="M11.5 12H21M17.5 12v3M20 12v2.2" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  reroll: (
    <>
      <path d="M19 8.5A7.5 7.5 0 0 0 5.2 9M5 15.5A7.5 7.5 0 0 0 18.8 15" />
      <path d="M19.5 4v4.5H15M4.5 20v-4.5H9" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  download: (
    <>
      <path d="M12 4v11M7.5 10.5L12 15l4.5-4.5" />
      <path d="M4.5 19.5h15" />
    </>
  ),
  leave: (
    <>
      <path d="M13 4.5H5.5v15H13" />
      <path d="M10 12h10M16.5 8.5L20 12l-3.5 3.5" />
    </>
  ),
  next: <path d="M5 12h13M13.5 7L18.5 12l-5 5" />,
  quill: (
    <>
      <path d="M19.5 4.5C12 5 7.5 10 6 18.5c3.5-4 7-6.5 11-7.5-2 0-3.5-.3-4.5-1 3-1.2 5.5-2.8 7-5.5z" />
      <path d="M4.5 20l2-2" />
    </>
  ),
  pin: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M12 12v8.5" />
    </>
  ),
  lang: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.6 2.4 3.8 5.2 3.8 8.5s-1.2 6.1-3.8 8.5c-2.6-2.4-3.8-5.2-3.8-8.5S9.4 5.9 12 3.5z" />
    </>
  ),
  bot: (
    <>
      <path d="M6 9h12v10H6zM12 5v4M9.5 13.5h.01M14.5 13.5h.01M9.5 16.5h5" />
      <circle cx="12" cy="4.5" r="1" />
    </>
  ),
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 22, label }: { name: IconName; size?: number; label?: string }) {
  return (
    <svg
      class="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
    >
      {PATHS[name]}
    </svg>
  );
}
